module.exports = __webpack_public_path__ + "8aae71ed32ce847591a49b07a6026edc.svg";